import * as React from 'react';
import Svg, { SvgProps, Path } from 'react-native-svg';

const SearchIcon16 = (props: SvgProps) => <Svg
  width={16}
  height={16}
  viewBox='0 0 16 16'
  fill='none'
  {...props}
>
  <Path
    d='M7.33333 12.6667C10.2789 12.6667 12.6667 10.2789 12.6667 7.33333C12.6667 4.38781 10.2789 2 7.33333 2C4.38781 2 2 4.38781 2 7.33333C2 10.2789 4.38781 12.6667 7.33333 12.6667Z'
    stroke='#003A70'
    strokeLinecap='round'
    strokeLinejoin='round'
  />
  <Path
    d='M13.9996 13.9938L11.0996 11.0938'
    stroke='#003A70'
    strokeLinecap='round'
    strokeLinejoin='round'
  />
</Svg>;

export default SearchIcon16;
